import { Box, Heading, Tabs } from "@radix-ui/themes";
import {
  InfoCircledIcon,
  MixerHorizontalIcon,
  TableIcon,
} from "@radix-ui/react-icons";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InfoTab } from "./InfoTab";
import { FilterTab } from "./FilterTab";
import { RawDataTab } from "./RawDataTab";
import { hasRawData } from "../../../../state/raw-data";
import type { ImportMeta } from "../../../../lib/import-db";

interface PlanningPhaseProps {
  importRecord: ImportMeta;
  onCleared: () => void;
}

export function PlanningPhase({ importRecord, onCleared }: PlanningPhaseProps) {
  const { t } = useTranslation();
  const [showRawTab, setShowRawTab] = useState(false);

  useEffect(() => {
    hasRawData().then(setShowRawTab);
  }, []);

  return (
    <Box p="6">
      <Heading size="6" mb="4">
        {t("import.planTitle")}
      </Heading>

      <Tabs.Root defaultValue="info">
        <Tabs.List>
          <Tabs.Trigger value="info">
            <InfoCircledIcon style={{ marginRight: 6 }} />
            {t("import.infoTab")}
          </Tabs.Trigger>
          <Tabs.Trigger value="filter">
            <MixerHorizontalIcon style={{ marginRight: 6 }} />
            {t("import.filterTab")}
          </Tabs.Trigger>
          {showRawTab && (
            <Tabs.Trigger value="rawData">
              <TableIcon style={{ marginRight: 6 }} />
              {t("import.rawDataTab")}
            </Tabs.Trigger>
          )}
        </Tabs.List>

        <Box pt="4">
          <Tabs.Content value="info">
            <InfoTab importRecord={importRecord} onCleared={onCleared} />
          </Tabs.Content>

          <Tabs.Content value="filter">
            <FilterTab importRecord={importRecord} />
          </Tabs.Content>

          {showRawTab && (
            <Tabs.Content value="rawData">
              <RawDataTab />
            </Tabs.Content>
          )}
        </Box>
      </Tabs.Root>
    </Box>
  );
}
